import { render, staticRenderFns } from "./SideBarMembers.vue?vue&type=template&id=51c2fa16"
import script from "./SideBarMembers.vue?vue&type=script&lang=js"
export * from "./SideBarMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports